import { render, staticRenderFns } from "./Stock.vue?vue&type=template&id=6b373f10&scoped=true"
import script from "./Stock.vue?vue&type=script&lang=js"
export * from "./Stock.vue?vue&type=script&lang=js"
import style0 from "./Stock.vue?vue&type=style&index=0&id=6b373f10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b373f10",
  null
  
)

export default component.exports